import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column gap-sm" }
const _hoisted_2 = { class: "details__controls" }
const _hoisted_3 = { class: "text-capitalize-first" }
const _hoisted_4 = { style: {"overflow":"auto"} }
const _hoisted_5 = {
  class: "table table__flex",
  style: {"position":"relative"}
}
const _hoisted_6 = {
  class: "ps",
  style: {"text-align":"left"}
}
const _hoisted_7 = { class: "text-capitalize-first" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "d-flex gap-sm align-items-center" }
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = {
  class: "detail__controls",
  style: {}
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_LoaderContent = _resolveComponent("LoaderContent")!
  const _component_TraderOperatorFormPopup = _resolveComponent("TraderOperatorFormPopup")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showEditModal({})), ["prevent"])),
          href: "#",
          class: "form__btn form__btn--reset btn btn--2"
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('button.create')), 1)
        ])
      ]),
      _createVNode(_component_LoaderContent, { ref: "loader" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('labels.name')), 1)
                  ]),
                  _cache[3] || (_cache[3] = _createElementVNode("th", null, null, -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.items, (user) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: user.id,
                    class: ""
                  }, [
                    _createElementVNode("td", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", null, [
                          (user.isBlocked)
                            ? _withDirectives((_openBlock(), _createBlock(_component_SvgIcon, {
                                key: 0,
                                class: "icon icon__attention",
                                title: _ctx.helper.trans('labels.user_blocked'),
                                icon: "cancel"
                              }, null, 8, ["title"])), [
                                [
                                  _directive_b_tooltip,
                                  void 0,
                                  void 0,
                                  { hover: true }
                                ]
                              ])
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("span", null, _toDisplayString(user.name), 1),
                          _createElementVNode("small", null, _toDisplayString(user.email), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: ($event: any) => (_ctx.showEditModal(user)),
                          class: "btn btn-sm"
                        }, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.helper.trans('button.edit')), 1)
                        ], 8, _hoisted_12)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          (_ctx.response.totalCount > _ctx.response.items.length)
            ? (_openBlock(), _createBlock(_component_b_pagination, {
                key: 0,
                modelValue: _ctx.page,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((_ctx.page) = $event)),
                  _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadList()))
                ],
                "total-rows": _ctx.response.totalCount,
                "per-page": _ctx.response.limit,
                limit: 20,
                "prev-text": "Back",
                "next-text": "Next",
                align: "start",
                "first-number": "",
                "hide-goto-end-buttons": "",
                "hide-ellipsis": ""
              }, null, 8, ["modelValue", "total-rows", "per-page"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512)
    ]),
    _createVNode(_component_TraderOperatorFormPopup, {
      onUpdated: _ctx.loadList,
      ref: "traderOperatorFormPopup"
    }, null, 8, ["onUpdated"])
  ], 64))
}